import React from 'react';
import styles from './ProfilePageHeader.module.css';

export default () => {
  const title = 'Profile page';

  return (
    <div className={styles.container}>
      <div className={styles.title}>{title}</div>
      <div className={styles.rightContainer} />
    </div>
  );
};
